"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function contains(target, container) {
    var isContainedInContainer = container && container.contains(target);
    var isContainedInDetachedFlyout = false;
    if (!isContainedInContainer) {
        var detachedFlyoutContainingTarget_1 = target.closest('.pb-detached-flyout');
        var targetIsInDetachedFlyout = !!detachedFlyoutContainingTarget_1;
        if (targetIsInDetachedFlyout) {
            var detachedFlyoutPlaceholdersInContainer = container.querySelectorAll('[data-detached-flyout-placeholder]');
            isContainedInDetachedFlyout = Array.prototype.slice.call(detachedFlyoutPlaceholdersInContainer)
                .some(function (element) { return $(element).data().dataDetachedFlyoutPlaceholder[0] === detachedFlyoutContainingTarget_1; });
        }
    }
    return isContainedInContainer || isContainedInDetachedFlyout;
}
exports.contains = contains;
